import type { ISerialize } from '@/objects/ISerialize';
import type { SwapContestantType } from './../enums/SwapContestantType';

export class SwapContestantRequest implements ISerialize {
    public Contestant1ID: number;

    public Contestant2ID: number;

    public IncludeStarttingTimes: boolean;

    public RaceContestant1ID: number | null;

    public RaceContestant2ID: number | null;

    public Type: SwapContestantType;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: {
        Contestant1ID?: number;
        Contestant2ID?: number;
        IncludeStarttingTimes?: boolean;
        RaceContestant1ID?: number | null;
        RaceContestant2ID?: number | null;
        Type?: SwapContestantType;
    }) {
        this.Contestant1ID = values.Contestant1ID ?? 0;

        this.Contestant2ID = values.Contestant2ID ?? 0;

        this.IncludeStarttingTimes = values.IncludeStarttingTimes ?? false;

        this.RaceContestant1ID = values.RaceContestant1ID ?? null;

        this.RaceContestant2ID = values.RaceContestant2ID ?? null;

        this.Type = values.Type ?? 'Bibs';
    }

    public serialize(): string {
        return (
            '{' +
            `"Contestant1ID": ${JSON.stringify(this.Contestant1ID)}` +
            ',' +
            `"Contestant2ID": ${JSON.stringify(this.Contestant2ID)}` +
            ',' +
            `"IncludeStarttingTimes": ${JSON.stringify(this.IncludeStarttingTimes)}` +
            ',' +
            `"RaceContestant1ID": ${JSON.stringify(this.RaceContestant1ID)}` +
            ',' +
            `"RaceContestant2ID": ${JSON.stringify(this.RaceContestant2ID)}` +
            ',' +
            `"Type": ${this.Type == 'Bibs' ? 0 : this.Type == 'Chips' ? 1 : 0}` +
            '}'
        );
    }

    /**
     * Creates an instance of SwapContestantRequest from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: {
        Contestant1ID?: number;
        Contestant2ID?: number;
        IncludeStarttingTimes?: boolean;
        RaceContestant1ID?: number | null;
        RaceContestant2ID?: number | null;
        Type?: SwapContestantType;
    }): SwapContestantRequest {
        return new SwapContestantRequest(values);
    }

    public static _FromServerJson(json: any): SwapContestantRequest {
        return new SwapContestantRequest({
            Contestant1ID: json.Contestant1ID,
            Contestant2ID: json.Contestant2ID,
            IncludeStarttingTimes: json.IncludeStarttingTimes,
            RaceContestant1ID: json.RaceContestant1ID ?? null,
            RaceContestant2ID: json.RaceContestant2ID ?? null,
            Type: json.Type == 0 ? 'Bibs' : json.Type == 1 ? 'Chips' : 'Bibs',
        });
    }

    /**
     * Creates an instance of SwapContestantRequest from another instance of SwapContestantRequest.
     * @param other The SwapContestantRequest you want to clone
     * @returns A cloned SwapContestantRequest
     */
    public static FromOther(other: SwapContestantRequest): SwapContestantRequest {
        return SwapContestantRequest._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return SwapContestantRequest.FromOther(this);
    }

    static NAME_OF_CLASS = 'SwapContestantRequest';
}
